import { render } from "./LeadDetails.vue?vue&type=template&id=5d45fa32&ts=true"
import script from "./LeadDetails.vue?vue&type=script&lang=ts"
export * from "./LeadDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__